import styled, { css } from "styled-components";

import { RideStatusDelayToColor } from "@ryde/controls";
import {
  DATA_E2E_KEY,
  IStyledAttributes,
  RideDelayStatusEnum,
} from "@ryde/shared";
import { greyMui } from "@ryde/theme";

import { buildLiveMapDelayStatusChipPalette } from "./live-map.grid-status-breakdown.utils";

interface ILiveMapGridStatusChipButtonStyledProps extends IStyledAttributes {
  $isVisible: boolean;
  $status: RideDelayStatusEnum;
}

const visibleStatusChipStyles = (status: RideDelayStatusEnum) => {
  const palette = buildLiveMapDelayStatusChipPalette(
    RideStatusDelayToColor[status],
  );

  return css`
    border: 1px solid ${palette.borderColor};
    background-color: ${palette.backgroundColor};
    color: ${palette.color};

    &:hover {
      box-shadow: 0 0 0 1px ${palette.hoverShadowColor};
    }

    &:focus-visible {
      outline: 2px solid ${palette.focusOutlineColor};
      outline-offset: 1px;
    }
  `;
};

export const LiveMapGridStatusChipButtonStyled = styled.button.attrs<ILiveMapGridStatusChipButtonStyledProps>(
  {
    type: "button",
    [DATA_E2E_KEY]: "live-map-grid-status-chip",
  },
)<ILiveMapGridStatusChipButtonStyledProps>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding-block: 2px;
  padding-inline: 7px;
  border-radius: 10px;
  font: inherit;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.3;
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
  appearance: none;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    opacity 0.15s ease,
    box-shadow 0.15s ease;

  ${({ $status, $isVisible }) =>
    $isVisible
      ? visibleStatusChipStyles($status)
      : css`
          border: 1px solid ${greyMui._300};
          background-color: ${greyMui._100};
          color: ${greyMui._500};
          opacity: 0.72;

          .live-map-grid-status-chip-label {
            text-decoration: line-through;
            text-decoration-color: ${greyMui._400};
          }

          .live-map-grid-status-chip-count {
            opacity: 0.85;
          }

          &:hover {
            opacity: 0.9;
            box-shadow: none;
          }
        `}

  .live-map-grid-status-chip-label {
    font-weight: 500;
  }

  .live-map-grid-status-chip-count {
    font-weight: 600;
    font-variant-numeric: tabular-nums;
  }
`;

export const LiveMapGridStatusChipTooltipTriggerStyled = styled.span.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "live-map-grid-status-chip-tooltip-trigger",
  },
)`
  display: inline-flex;
  color: inherit;
  background-color: transparent;
`;
